import { catchError, map, Observable, ObservableInput, of, throwError } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { SettingsService } from './settings.service';
import { environment } from '../../environments/environment';

type CatchErrorHandler = (err: any, caught?: Observable<any>) => ObservableInput<any>;

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  constructor(
    private settingService: SettingsService,
    private messageService: MessageService,
    private http: HttpClient
  ) {}

  private extractErrorMessage(err: any): string {
    const lang = this.settingService.selectedLang;
    const requestInfo = err.url ? ` [URL: ${err.url}]` : '';
    const bodyInfo = err.body ? ` [Body: ${JSON.stringify(err.body)}]` : '';

    if (err instanceof Error) {
      return this.settingService.getTranslate('error_err', [err.message || err.toString()]);
    }

    if (err instanceof HttpErrorResponse) {
      if (err.status === 0 || err.status === 504) {
        return this.settingService.getTranslate('no_server_connection') + requestInfo + bodyInfo;
      }

      const errMsg = err.error?.data || `${err.status} ${err.message}`;
      const parts = errMsg.split('-|');
      return parts[1] || this.settingService.getTranslate('error_err', [errMsg]);
    }

    if (err.error instanceof ErrorEvent) {
      return this.settingService.getTranslate('error_err', [err.error.message]);
    }

    if (err.error?.data) {
      const parts = err.error.data.split('-|');
      const msg = parts[1] || err.error.data;
      return this.settingService.getTranslate('error_err', [`${err.status} ${msg}`]);
    }

    if (err.error) {
      return this.settingService.getTranslate('error_err', [err.error.err || err.message]);
    }

    return this.settingService.getTranslate('unknown_error', ['']);
  }

  catchErrorhandler: CatchErrorHandler = (err: any, caught?: Observable<any>) => {
    const errorMessage = this.extractErrorMessage(err);
    const severity = 'error';
    const summary = this.settingService.translate[this.settingService.selectedLang]['error'];

    this.sendLog('error', errorMessage).subscribe(
      () => {},
      (err) => console.error('sendLog error:', err)
    );

    this.messageService.clear();
    this.messageService.add({
      severity,
      summary,
      detail: errorMessage,
      life: 7000,
    });

    console.error(errorMessage);
    return throwError(() => new Error(errorMessage));
  };

  sendLog(action: string, data: string): Observable<void> {
    // Не отправляем логи в режиме разработки
    if (!environment.production) {
      console.log('[sendLog]', action, data);
      return of(undefined);
    }
    return this.http
      .post(`${this.settingService.settings.urlGTM}/api/service/log/`, {
        action,
        data,
      })
      .pipe(
        map(() => undefined),
        catchError((error) => {
          if (action === 'error') {
            console.error('sendLog error:', error);
            return of(undefined);
          }
          return throwError(() => error);
        })
      );
  }
}
